<template>
  <div class="admin-wrapper">
    <section class="hero is-info is-small">
      <div class="hero-body">
        <h1 class="title is-1">{{job.status}}</h1>
        <p class="title">{{job.guid}} (guid)</p>
      </div>
    </section><br><br>

    <!-- Video Creation Stats -->
    <section class="columns stats">
      <div class="column">
        <el-card class="box-card">
          <img :src="`https://s3-us-west-2.amazonaws.com/wavvegram/background/${job.specs.backgroundImage}`"
            class="image" style="max-height: 200px;">
        </el-card>
      </div>
      <div class="column">
        <el-card class="box-card">
          <p class="title">{{job.specs.pattern}}</p>
          <p class="subtitle">Pattern</p>
        </el-card>
      </div>
      <div class="column">
        <el-card class="box-card">
          <p class="title">{{job.specs.progressBar}}</p>
          <p class="subtitle">progressBar</p>
        </el-card>
      </div>
    </section><br><br><br><br><hr>
    <h1>Theme Details</h1>
    <pre>{{job.specs}}</pre>
  </div>
</template>

<script>
import moment from 'moment';
import JobService from '@/api/job.service';
import '@/style/admin.scss';

export default {
  name: 'job',
  filters: {
    moment: date => moment(date).format('MM-DD-YYYY')
  },
  data() {
    return {
      job: {
        specs: {}
      },
      me: this.$store.state.user
    }
  },

  created() {
    this.getJob();
  },

  methods: {
    async getJob() {
      const id = window.location.pathname.split('/').pop();
      this.job = await JobService.get(id);
    }
  }
}
</script>
